import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBarsThree3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBarsThree3"><Path fillRule="evenodd" clipRule="evenodd" d="M2 5.5C2 5.22386 2.22386 5 2.5 5H21.5C21.7761 5 22 5.22386 22 5.5C22 5.77614 21.7761 6 21.5 6H2.5C2.22386 6 2 5.77614 2 5.5ZM2 12C2 11.7239 2.22386 11.5 2.5 11.5H13.5C13.7761 11.5 14 11.7239 14 12C14 12.2761 13.7761 12.5 13.5 12.5H2.5C2.22386 12.5 2 12.2761 2 12ZM2 18.5C2 18.2239 2.22386 18 2.5 18H21.5C21.7761 18 22 18.2239 22 18.5C22 18.7761 21.7761 19 21.5 19H2.5C2.22386 19 2 18.7761 2 18.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBarsThree3;
